import { render, staticRenderFns } from "./SetupPageComponent.vue?vue&type=template&id=3842cb2b&scoped=true"
import script from "./SetupPageComponent.vue?vue&type=script&lang=js"
export * from "./SetupPageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842cb2b",
  null
  
)

export default component.exports